<template>
  <v-layout
    row
    wrap
  >
    <v-flex xs12>
      <v-card class="max-shadow">
        <v-toolbar
          :class="{ 'elevation-2': scrolled}"
          height="64"
          color="white"
          flat
        >
          <v-btn
            icon
            @click="$router.back()"
          >
            <v-icon color="iconColor">
              arrow_back
            </v-icon>
          </v-btn>
          <v-toolbar-title>
            Import Employees
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              color="primary"
              flat
              href="Sample.csv"
            >
              <v-icon>get_app</v-icon>&nbsp;Sample.CSV
            </v-btn>
            <v-btn
              :disabled="importedEmployees.length === 0"
              color="primary"
              flat
              @click="_saveEmployees"
            >
              Save
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <div v-scroll:#importEmployeesContentWOToolbar="onScroll">
          <v-layout
            id="importEmployeesContentWOToolbar"
            row
            wrap
            class="pa-3"
          >
            <v-flex>
              <v-layout
                row
                wrap
              >
                <v-flex
                  xs12
                  sm3
                  class="drop-zone grey lighten-4"
                  @mouseover="dropZoneHovered = !dropZoneHovered"
                  @mouseout="dropZoneHovered = !dropZoneHovered"
                  @click="$refs.fileInput.click()"
                >
                  <v-icon
                    :size="72"
                    :class="dropZoneColor"
                  >
                    description
                  </v-icon>
                  <div
                    :class="dropZoneColor"
                    class="subheading fw-500"
                  >
                    {{ fileName }}
                  </div>
                  <input
                    ref="fileInput"
                    type="file"
                    accept=".csv"
                    hidden
                    @change="_fileSelected"
                  >
                </v-flex>
                <v-flex sm9>
                  <div class="px-4 grey--text text--darken-1 subheading">
                    <p>Upload a CSV file to import Employees.</p>

                    <p><strong>Your CSV must:</strong></p>
                    <ul class="pl-5 wrap">
                      <li>
                        Not include header in the file. i.e first line in the CSV should be one employee,
                        not field names
                      </li>
                      <li><strong>List one employee per line</strong></li>
                      <li>Contain a unique email address for each employee</li>
                      <li>
                        Match the following format:
                        <div class="format-sample my-2 pa-2 grey lighten-4">
                          <span>"Full Name"</span>, <span>"Email"</span>, <span>"Mobile"</span>,
                          <span>"Designation"</span>
                        </div>
                      </li>
                    </ul>
                    <p><strong>Note:</strong> mobile number and designation are optional.</p>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex
              xs12
              class="pt-3"
            >
              <div class="subheading fw-500">
                Employees Preview
              </div>
              <div class="body-2 py-2 grey--text text--darken-2">
                Please review and ensure that the below list contains all employees and correct contact
                information
              </div>
              <v-data-table
                :headers="employeesHeaders"
                :items="importedEmployees"
                class="px-2 pb-2"
                item-key="id"
                no-data-text="Please select csv file for preview"
                hide-actions
                disable-initial-sort
              >
                <template
                  slot="items"
                  slot-scope="props"
                >
                  <tr>
                    <td>{{ props.index + 1 }}</td>
                    <td class="text-xs-left">
                      {{ props.item.name }}
                    </td>
                    <td class="text-xs-left">
                      {{ props.item.email }}
                    </td>
                    <td class="text-xs-left">
                      {{ props.item.phone }}
                    </td>
                    <td class="text-xs-left">
                      {{ props.item.designation }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </div>
        <v-snackbar
          v-model="snackbar.show"
          :color="snackbar.color"
          :timeout="0"
          :multi-line="snackbar.multiLine"
          bottom
        >
          {{ snackbar.message }}
          <v-btn
            flat
            @click.native="snackbar.show = false"
          >
            Close
          </v-btn>
        </v-snackbar>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import Papa from 'papaparse';
import * as libphonenumber from 'libphonenumber-js';
import { some as _some, omit as _omit } from 'lodash';

import { firestore } from '@/firebase';
import { generateUID } from '@/utils';

export default {
  name: 'ImportEmployees',
  data() {
    return {
      fileName: 'Click to select',
      employees: [],
      importedEmployees: [],
      employeesHeaders: [
        {
          text: '#',
          value: false,
          align: 'left'
        },
        {
          text: 'Name',
          value: 'name',
          align: 'left'
        },
        {
          text: 'Email',
          value: 'email',
          align: 'left'
        },
        {
          text: 'Phone',
          value: 'phone',
          align: 'left'
        },
        {
          text: 'Designation',
          value: 'designation',
          align: 'left'
        }
      ],
      dropZoneHovered: false,
      offsetTop: 0,
      snackbar: {
        show: false,
        message: '',
        color: 'primary',
        multiLine: false
      },
      papa: {
        currentLine: 0,
        errors: []
      },
      saveButton: {
        loading: false
      }
    };
  },
  computed: {
    dropZoneColor() {
      return this.dropZoneHovered
        ? 'primary--text text--lighten-1'
        : 'grey--text text--darken-1';
    }
  },
  watch: {
    offsetTop: {
      handler(val) {
        if (val > 10) {
          this.scrolled = true;
        } else {
          this.scrolled = false;
        }
      },
      immediate: true
    }
  },
  created() {
    firestore
      .collection('tenants')
      .doc(this.$store.state.profile.cid)
      .collection('employees')
      .get()
      .then(employeesSnapshot => {
        this.employees = [];
        employeesSnapshot.forEach(employeeSnapshot => {
          const employee = employeeSnapshot.data();
          employee.id = employeeSnapshot.id;
          this.employees.push(employee);
        });
      });
  },
  methods: {
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
    _fileSelected() {
      // clear previous data
      this.importedEmployees = [];
      this.papa = {
        currentLine: 0,
        errors: []
      };

      const input = this.$refs.fileInput;
      if (input.files && input.files[0]) {
        const file = input.files[0];

        Papa.parse(file, {
          delimiter: '', // auto-detect
          newline: '', // auto-detect
          quoteChar: '"',
          header: false,
          step: this._papaStep.bind(this),
          complete: () => {
            if (this.papa.errors.length) {
              const csv = Papa.unparse(this.papa.errors, {
                quotes: true,
                quoteChar: '"',
                delimiter: ',',
                header: true
              });
              // download errors as a file
              const blob = new Blob([csv], {
                type: 'text/csv;charset=utf-8;'
              });

              const filename = 'employees_import_errors.csv';
              if (navigator.msSaveBlob) {
                // IE 10+
                navigator.msSaveBlob(blob, filename);
              } else {
                const link = document.createElement('a');
                if (link.download !== undefined) {
                  // feature detection
                  // Browsers that support HTML5 download attribute
                  const url = URL.createObjectURL(blob);
                  link.setAttribute('href', url);
                  try {
                    link.setAttribute('download', filename);
                  } catch (error) {
                    // eslint-disable-next-line
                    console.log(error);
                  }
                  link.style.visibility = 'hidden';

                  link.click();
                }
              }

              this.snackbar = {
                show: true,
                color: 'warning',
                multiLine: true,
                message:
                  'Some lines are skipped due to errors. Please check downloaded errors file for more information'
              };
            }
          }
        });
      }
    },

    _papaStep(results) {
      this.papa.currentLine += 1;
      const data = results.data[0];
      if (data.length !== 4) {
        this.papa.errors.push({
          'Line No': this.papa.currentLine,
          Error: 'Expected 4 columns but found 1'
        });
        return;
      }
      const emp = {
        name: data[0].trim(),
        email: data[1].trim(),
        phone: data[2].trim(),
        designation: data[3].trim()
      };
      emp.phone = this._validateAndFormatPhone(emp.phone);

      if (!this._validateName(emp.name)) {
        this.papa.errors.push({
          'Line No': this.papa.currentLine,
          Error: 'Invalid Employee name'
        });
        return;
      }

      if (!this._validateEmail(emp.email)) {
        this.papa.errors.push({
          'Line No': this.papa.currentLine,
          Error: 'Invalid Employee email'
        });
        return;
      }

      if (
        _some(
          this.importedEmployees,
          o => o.email === emp.email || (!!emp.phone && o.phone === emp.phone)
        )
      ) {
        this.papa.errors.push({
          'Line No': this.papa.currentLine,
          Error: 'Duplicate employee record'
        });
        return;
      }

      if (
        _some(
          this.employees,
          o => o.email === emp.email || (!!emp.phone && o.phone === emp.phone)
        )
      ) {
        this.papa.errors.push({
          'Line No': this.papa.currentLine,
          Error: 'Employee already exists'
        });
        return;
      }

      emp.id = generateUID();
      this.importedEmployees.push(emp);
    },

    _saveEmployees() {
      this.saveButton.loading = true;
      const batch = firestore.batch();
      this.importedEmployees.forEach(employee => {
        const emp = _omit(employee, ['id']);
        const empRef = firestore
          .collection('tenants')
          .doc(this.$store.state.profile.cid)
          .collection('employees')
          .doc(employee.id);
        batch.set(empRef, emp);
      });
      batch
        .commit()
        .then(() => {
          this.$router.back();
        })
        .catch(error => {
          this.snackbar = {
            show: true,
            message: error.message,
            color: 'error',
            multiLine: true
          };
        })
        .then(() => {
          this.saveButton.loading = false;
        });
    },

    _validateName(name) {
      const nameRegex = /^[a-zA-Z ,.'-]{3,}$/;
      return nameRegex.test(name);
    },

    _validateEmail(email) {
      const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
      return emailRegex.test(email);
    },

    _validateAndFormatPhone(phone) {
      const parsed = libphonenumber.parse(phone, 'IN', { extended: true });
      return parsed.valid ? libphonenumber.formatNumber(parsed, 'E.164') : '';
    }
  }
};
</script>
<style scoped>
.drop-zone {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  border-radius: 3px;
}

.format-sample {
  font-size: 14px;
  font-family: monospace;
  width: fit-content;
  font-weight: 600;
}
#importEmployeesContent {
  height: calc(100vh - var(--toolbar-height));
}
#importEmployeesContentWOToolbar {
  height: calc(100vh - (var(--toolbar-height) + 62px));
  overflow-y: scroll;
}
</style>
